import Lottie from "lottie-react";
import Banners from "./banner6.json";
import {
  Animator,
  ScrollContainer,
  ScrollPage,
  batch,
  Fade,
  FadeIn,
  FadeOut,
  Move,
  MoveIn,
  MoveOut,
  Sticky,
  StickyIn,
  StickyOut,
  Zoom,
  ZoomIn,
  ZoomOut,
} from "react-scroll-motion";

const ScrollAnimation = () => {
  const ZoomInScrollOut = batch(StickyIn(), FadeIn(), ZoomIn());
  const FadeUp = batch(Fade(), Move(), Sticky());
  return (
    <div className="bg-gray-200">
      {/* <div className="bg-white relative">
        <div
          className="relative"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 auto",
            width: "1100px",
          }}
        >
          <img
            src="./images/tablet-1.png"
            style={{
              position: "relative",
              marginTop: "-170px",
            }}
          />
        </div>
      </div> */}
      <div className="flex container m-auto py-10 items-center ">
        <div className="w-[40%]">
          {/* <img src="./images/phone-13.png" /> */}
          <Lottie animationData={Banners} loop={true} />
        </div>
        <div className="w-[60%]">
          <h2 className=" text-5xl mb-3">
            Stay{" "}
            <strong className="text-indigo-500 font-bold">Connected</strong>.{" "}
            <strong className="text-indigo-500 font-bold">Stay in </strong>
            Control. Anywhere, Anytime.
          </h2>
          <p className="text-xl text-gray-700 mb-3">
            Take your transportation operations on the go with the TMS Mobile
            App — the ultimate tool for logistics teams, fleet managers, and
            drivers. Track shipments, manage loads, communicate with your team,
            and make data-driven decisions — all from your mobile device.
          </p>
          <ul className="grid grid-cols-3 gap-4 mt-5">
            <li className="flex space-x-3 mb-1">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-600 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span className="text-base leading-tight text-gray-700 dark:text-white">
                Real-Time Load Tracking
              </span>
            </li>
            <li className="flex space-x-3 mb-1">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-600 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span className="text-base leading-tight text-gray-700 dark:text-white">
                Driver & Fleet Management
              </span>
            </li>
            <li className="flex space-x-3 mb-1">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-600 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span className="text-base leading-tight text-gray-700 dark:text-white">
                Smart Load Assignments
              </span>
            </li>
            <li className="flex space-x-3 mb-1">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-600 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span className="text-base leading-tight text-gray-700 dark:text-white">
                Instant Notifications & Alerts
              </span>
            </li>
            <li className="flex space-x-3 mb-1">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-600 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span className="text-base leading-tight text-gray-700 dark:text-white">
                Document Upload & E-Signatures
              </span>
            </li>
            <li className="flex space-x-3 mb-1">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-600 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span className="text-base leading-tight text-gray-700 dark:text-white">
                Fuel & Expense Logging
              </span>
            </li>
            <li className="flex space-x-3 mb-1">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-600 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span className="text-base leading-tight text-gray-700 dark:text-white">
                In-App Chat & Communication
              </span>
            </li>
          </ul>
        </div>
      </div>
      {/*<ScrollContainer>
         <ScrollPage>
          <Animator animation={batch(Fade(1, 1), Sticky(), MoveOut(0, -200))}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "1000px",
              }}
            >
              <img src="./images/tablet-1.png" />
            </div>
          </Animator>
        </ScrollPage> */}
      {/* <ScrollPage className="bg-gray-100">
          <Animator animation={ZoomInScrollOut}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "1000px",
              }}
            >
              <img src="./images/tablet-1.png" />
            </div>
          </Animator>
        </ScrollPage> 

        <ScrollPage>
          <Animator animation={batch(Fade(), MoveIn(0, 1000), Sticky())}>
            <></>
            {/* <div
              className="flex"
              style={{
                justifyContent: "center",
                alignItems: "center",
                width: "900px",
              }}
            >
              <div className="flex-1">
               
                <Lottie animationData={Banners} loop={true} />
              </div>
              <div className="flex-1">
                <h2 className="font-bold text-2xl mb-3">
                  Stay Connected. Stay in Control. Anywhere, Anytime.
                </h2>
                <p className=" mb-3">
                  Take your transportation operations on the go with the TMS
                  Mobile App — the ultimate tool for logistics teams, fleet
                  managers, and drivers. Track shipments, manage loads,
                  communicate with your team, and make data-driven decisions —
                  all from your mobile device.
                </p>
                <ul className="list-disc ml-5">
                  <li className="flex space-x-3 mb-1">
                    <svg
                      className="flex-shrink-0 w-5 h-5 text-primary dark:text-purple-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                      Real-Time Load Tracking
                    </span>
                  </li>
                  <li className="flex space-x-3 mb-1">
                    <svg
                      className="flex-shrink-0 w-5 h-5 text-primary dark:text-purple-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                      Driver & Fleet Management
                    </span>
                  </li>
                  <li className="flex space-x-3 mb-1">
                    <svg
                      className="flex-shrink-0 w-5 h-5 text-primary dark:text-purple-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                      Smart Load Assignments
                    </span>
                  </li>
                  <li className="flex space-x-3 mb-1">
                    <svg
                      className="flex-shrink-0 w-5 h-5 text-primary dark:text-purple-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                      Instant Notifications & Alerts
                    </span>
                  </li>
                  <li className="flex space-x-3 mb-1">
                    <svg
                      className="flex-shrink-0 w-5 h-5 text-primary dark:text-purple-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                      SDocument Upload & E-Signatures
                    </span>
                  </li>
                  <li className="flex space-x-3 mb-1">
                    <svg
                      className="flex-shrink-0 w-5 h-5 text-primary dark:text-purple-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                      Fuel & Expense Logging
                    </span>
                  </li>
                  <li className="flex space-x-3 mb-1">
                    <svg
                      className="flex-shrink-0 w-5 h-5 text-primary dark:text-purple-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                      In-App Chat & Communication
                    </span>
                  </li>
                </ul>
              </div>
            </div> 
          </Animator>
        </ScrollPage>

        {/*
        <ScrollPage>
          <Animator
            animation={batch(Fade(), MoveIn(0, 1000), Sticky())}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "1000px",
              }}
            >
              <div>
                <h2 className="font-bold text-2xl mb-3">
                  Direct and multiplex connections all over the world.
                </h2>
                <p className=" mb-3">
                  Lorem ipsum dolor sit ametno sea takimata sanctus est Lorem
                  ipsum dolor sit amete. Ut enim ad minim veniam.
                </p>
                <ul className="list-disc ml-5">
                  <li>Lorem ipsum dolor sit ameteminim veniam amoartes.</li>
                  <li>
                    Lorem exercitation ipsum dolor sittakimata amete magna
                    doloros.
                  </li>
                  <li>Aullamco ipsum dolor sit amete sanctus artes.</li>
                </ul>
              </div>
              <div>
                <img src="./images/phone-12.png" style={{ width: "1200px" }} />
              </div>
            </div>
          </Animator>
        </ScrollPage> */}
      {/* <ScrollPage>
        <Animator animation={FadeUp}>
          <span style={{ fontSize: "40px" }}>I'm FadeUp ⛅️</span>
        </Animator>
      </ScrollPage>
      <ScrollPage>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <span style={{ fontSize: "40px" }}>
            <Animator animation={MoveIn(-1000, 0)}>Hello Guys 👋🏻</Animator>
            <Animator animation={MoveIn(1000, 0)}>Nice to meet you 🙋🏻‍♀️</Animator>
            - I'm Dante Chun -
            <Animator animation={MoveOut(1000, 0)}>Good bye ✋🏻</Animator>
            <Animator animation={MoveOut(-1000, 0)}>See you 💛</Animator>
          </span>
        </div>
      </ScrollPage>
      <ScrollPage>
        <Animator animation={batch(Fade(), Sticky())}>
          <span style={{ fontSize: "40px" }}>Done</span>
          <br />
          <span style={{ fontSize: "30px" }}>
            There's FadeAnimation, MoveAnimation, StickyAnimation, ZoomAnimation
          </span>
        </Animator>
      </ScrollPage>
      </ScrollContainer>
       */}
    </div>
  );
};

export default ScrollAnimation;
